var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "chat-group" }, [
    _c("div", { staticClass: "group-header" }, [
      _c(
        "div",
        { staticClass: "agent-info" },
        [
          _vm.group.id
            ? _c("AgentAvatar", {
                key: _vm.group.id,
                attrs: { size: 40, "font-size": 14, userID: _vm.group.id },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("h2", { staticClass: "agent-name" }, [
            _vm._v(_vm._s(_vm.getAgentName(_vm.group.id))),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "group-stats" }, [
        _c("div", { staticClass: "stat-item" }, [
          _c("i", { staticClass: "material-icons" }, [_vm._v("person")]),
          _vm._v(" "),
          _c("span", { staticClass: "stat-label" }, [
            _vm._v(_vm._s(_vm.$t("chatWindow.totalCustomer"))),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "stat-value" }, [
            _vm._v(_vm._s(_vm.groupStats.totalCustomers)),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "stat-item" }, [
          _c("i", { staticClass: "material-icons" }, [_vm._v("description")]),
          _vm._v(" "),
          _c("span", { staticClass: "stat-label" }, [
            _vm._v(_vm._s(_vm.$t("chatWindow.unanswered"))),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "stat-value" }, [
            _vm._v(_vm._s(_vm.groupStats.unanswered)),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "stat-item" }, [
          _c("i", { staticClass: "material-icons" }, [_vm._v("check_circle")]),
          _vm._v(" "),
          _c("span", { staticClass: "stat-label" }, [
            _vm._v(_vm._s(_vm.$t("chatWindow.answered"))),
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "stat-value" }, [
            _vm._v(_vm._s(_vm.groupStats.answered)),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "watch-all-btn", on: { click: _vm.handleWatchAll } },
        [
          _c("i", { staticClass: "material-icons" }, [_vm._v("visibility")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("message.watchAllLive")))]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "customers" },
      _vm._l(_vm.group.items, function (item) {
        return _c("CustomerCard", {
          key: item.name,
          attrs: {
            item: item,
            "group-id": _vm.group.id,
            "agent-name": _vm.getAgentName(_vm.group.id),
            "selected-item-id": _vm.selectedItemId,
          },
          on: { select: _vm.handleCustomerSelect },
        })
      }),
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }